const _excluded = ["className", "buttonClassname", "textfieldClassname", "value", "onClick", "onError", "onCopy", "buttonLabel"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React, { useRef, useState } from 'react';
import cn from 'classnames';
import styles from "./CopyToClipboard.module.scss";
import { Button, TextField } from 'seagull';
import { Checkmark, CopyLiner24 } from 'seagull/icons';
import { useIoContext } from "../../contexts";
export function CopyToClipboard(props) {
  const {
      className,
      buttonClassname,
      textfieldClassname,
      value,
      onClick: _onClick,
      onError,
      onCopy,
      buttonLabel
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const dataTestId = props['data-testid'] || 'copy-to-clipboard';
  const {
    copyToClipboard
  } = useIoContext();
  const inputRef = useRef();
  const [isCopied, setIsCopied] = useState(false);
  const [hasError, setHasError] = useState(false);
  const ButtonWrapper = _ref => {
    let {
      children
    } = _ref;
    return buttonClassname ? /*#__PURE__*/React.createElement("div", {
      className: buttonClassname
    }, children) : /*#__PURE__*/React.createElement(React.Fragment, null, children);
  };
  const TextfieldWrapper = _ref2 => {
    let {
      children
    } = _ref2;
    return textfieldClassname ? /*#__PURE__*/React.createElement("div", {
      className: textfieldClassname
    }, children) : /*#__PURE__*/React.createElement(React.Fragment, null, children);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.root, className),
    "data-testid": dataTestId
  }, /*#__PURE__*/React.createElement(TextfieldWrapper, null, /*#__PURE__*/React.createElement(TextField, _extends({
    inputProps: {
      readOnly: true
    },
    value: value,
    inputRef: inputRef,
    onClick: () => {
      var _inputRef$current;
      return (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.select();
    },
    onCopy: onCopy,
    className: styles.input,
    helperText: hasError ? 'Copy failed. Please try manually or give it another shot later.' : undefined,
    error: hasError
  }, rest, {
    "data-testid": "".concat(dataTestId, "-input")
  }))), /*#__PURE__*/React.createElement(ButtonWrapper, null, /*#__PURE__*/React.createElement(Button, {
    "data-testid": "".concat(dataTestId, "-button"),
    prefixIcon: isCopied ? /*#__PURE__*/React.createElement(Checkmark, null) : /*#__PURE__*/React.createElement(CopyLiner24, null),
    onClick: () => {
      try {
        if (_onClick) _onClick();
        if (!value) return;
        copyToClipboard(value);
        setIsCopied(true);
        onCopy && onCopy();
        setTimeout(() => setIsCopied(false), 2000);
      } catch (e) {
        setHasError(true);
        setTimeout(() => setHasError(false), 2000);
        if (onError) onError();
      }
    },
    loading: !value,
    disabled: isCopied,
    className: styles.button
  }, isCopied ? 'Copied' : buttonLabel || 'Copy link')));
}